import { render, staticRenderFns } from "./OrderStatusField.vue?vue&type=template&id=134487a2&"
import script from "./OrderStatusField.vue?vue&type=script&lang=js&"
export * from "./OrderStatusField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('134487a2')) {
      api.createRecord('134487a2', component.options)
    } else {
      api.reload('134487a2', component.options)
    }
    module.hot.accept("./OrderStatusField.vue?vue&type=template&id=134487a2&", function () {
      api.rerender('134487a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/orders/fields/OrderStatusField.vue"
export default component.exports